import EmptyPlaceholder from "../../../controls/EmptyPlaceholder";
import { ComponentEx, connect } from "../../../controls/ComponentEx";
import opn from "../../../util/opn";
import { bytesToString } from "../../../util/util";
import * as React from "react";
class GameInfoPopover extends ComponentEx {
    mMounted = false;
    constructor(props) {
        super(props);
        this.state = { loading: false };
    }
    componentDidMount() {
        const { game, onRefreshGameInfo } = this.props;
        this.mMounted = true;
        if (onRefreshGameInfo !== undefined) {
            this.setState({ loading: true });
            onRefreshGameInfo(game.id).then(() => {
                if (this.mMounted) {
                    this.setState({ loading: false });
                }
            });
        }
    }
    componentWillUnmount() {
        this.mMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.discoveredGames !== nextProps.discoveredGames &&
            nextProps.onRefreshGameInfo !== undefined) {
            // A change in discovered games would suggest that the player has
            //  modified the game's path - We need to refresh the game information
            //  object.
            nextProps.onRefreshGameInfo(nextProps.game.id);
        }
        if (this.props.gameInfo !== nextProps.gameInfo) {
            nextProps.onChange();
        }
    }
    render() {
        const { t } = this.props;
        const gameInfo = this.props.gameInfo || {};
        const keysToRender = Object.keys(gameInfo)
            .sort((lhs, rhs) => (gameInfo[lhs].priority ?? 100) - (gameInfo[rhs].priority ?? 100))
            .filter((key) => gameInfo[key].value !== null);
        if (keysToRender.length === 0) {
            return (React.createElement(EmptyPlaceholder, { icon: "layout-list", text: t("No Information about this game") }));
        }
        return (React.createElement("div", { className: "game-info-grid" }, keysToRender.map(this.renderGameInfo)));
    }
    renderGameInfo = (key) => {
        const { t, gameInfo } = this.props;
        return [
            React.createElement("div", { key: `${key}-title`, className: "game-info-title" }, t(gameInfo[key].title)),
            React.createElement("div", { key: `${key}-value`, className: "game-info-value" }, this.renderValue(gameInfo[key].value, gameInfo[key].type || "string")),
        ];
    };
    renderValue = (value, type) => {
        const { language } = this.props;
        if (type === "date") {
            return new Date(value).toLocaleString(language);
        }
        else if (type === "url") {
            return (React.createElement("a", { onClick: this.openUrl, href: value }, value));
        }
        else if (type === "bytes") {
            return bytesToString(value);
        }
        else {
            return value;
        }
    };
    openUrl = (evt) => {
        evt.preventDefault();
        opn(evt.currentTarget.href).catch((err) => undefined);
    };
}
function mapStateToProps(state, ownProps) {
    return {
        discoveredGames: state.settings.gameMode.discovered,
        gameInfo: state.persistent.gameMode.gameInfo?.[ownProps.game.id],
        language: state.settings.interface.language,
    };
}
export default connect(mapStateToProps)(GameInfoPopover);
